import React from 'react';
import { Navigate } from 'react-router-dom';
import { Result, Button } from 'antd';
import { usePermissions } from '../../hooks/usePermissions';

const FeatureGuard = ({ feature, children, fallbackPath = '/home' }) => {
  const { hasPermission, loading } = usePermissions();

  // Show loading state while permissions are being fetched
  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-center">
          <div className="text-lg">Loading...</div>
        </div>
      </div>
    );
  }

  // Check if user has permission for this feature
  const hasFeaturePermission = hasPermission(feature);

  if (!hasFeaturePermission) {
    return (
      <Result
        status="403"
        title="Access Denied"
        subTitle={`You don't have permission to access the ${feature} feature. Please contact your administrator if you believe this is an error.`}
        extra={
          <Button type="primary" onClick={() => window.location.href = fallbackPath}>
            Go to Home
          </Button>
        }
      />
    );
  }

  return children;
};

export default FeatureGuard;
